<template>
  <div data-component="Widget/CloseButton" class="close-button">
    <a 
      :href="to || referer" 
      @click="handleClick"
      class="close-link"
    >
      Fermer
      &nbsp;<i class="ico close"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CloseButton',
  props: {
    to: {
      type: String,
      default: null
    },
    referer: {
      type: String,
      default: null
    },
    doBack: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      
      if (this.onClose) {
        this.onClose()
        return
      }

      const targetUrl = this.to || this.referer
      
      if (this.doBack && this.referer) {
        this.$router.push(this.referer)
      } else if (targetUrl) {
        this.$router.push(targetUrl)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
